import React from "react";
export default function NoResultsPanel(props) {
  return (
    <React.Fragment>
      <div className="individuals__notice notice">
        <h5>No results for experienced Companies or PRO members.</h5>

        <p>Try expanding your filters or searching for something else.</p>
      </div>
      <div className="individuals__dialog dialog">
        <h6>We can help. Free, personalized support.</h6>

        <p>
          WoodWorks provides free one-on-one project assistance related to the
          code-compliant design, engineering, and construction of commercial and
          multi-family wood buildings.
        </p>

        <div className="dialog__actions">
          <a
            href="https://www.woodworks.org/project-assistance-map/?utm_source=website&utm_medium=WIN_website&utm_campaign=project-assistance-map-link"
            target="_blank"
            className="btn btn--outline"
          >
            Get Free Project Support
          </a>
        </div>
      </div>
    </React.Fragment>
  );
}
